import React, { useState, useContext } from "react";
import {
  Collapse,
  Container,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  NavbarText,
} from "reactstrap";
import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import { RootStoreContext } from "../core/store/rootStore";
import "./shared.css"
import Role from "./enums/roleEnum";
import UserModal from "../components/user/user.modal";

const NavMenu = () => {
  const rootStore = useContext(RootStoreContext);
  const { openModal } = rootStore.modalStore;
  const { logout, user, getRole } = rootStore.userStore;

  const [collapsed, setCollapsed] = useState(true);

  const currentUser = Object.assign({}, user);

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  function GetAdministrationLink() {
    if (getRole === Role.ADMIN) {
      return <NavLink tag={Link} className="nav-menu-color" to="/administration">
                Administration
             </NavLink>
    }

    return null;
  }

  function GetCompaniesLink() {
    if (getRole === Role.SUPER_ADMIN) {
      return <NavLink tag={Link} className="nav-menu-color" to="/companies">
        Enterprises
      </NavLink>
    }

    return null;
  }

  function GetProfileLink() {
    if (getRole === Role.USER) {
      return <NavLink tag={Link} className="nav-menu-color" onClick={openProfile}>
        Profil
      </NavLink>
    }

    return null;
  }

  function GetLogsLink() {
    if (getRole === Role.ADMIN || getRole === Role.USER) {
      return <NavLink tag={Link} className="nav-menu-color" to="/logs">
        Logs
      </NavLink>
    }

    return null;
  }

  function openProfile() {
    openModal(<UserModal />, currentUser, null, "xl");
  }

  return (
    <header>
      <Navbar
        className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3"
        light
      >
        <Container>
          <NavbarBrand tag={Link} to="/">
            <img src="/logo.png" alt="logo" width="150px" />
          </NavbarBrand>
          <NavbarToggler onClick={toggleNavbar} className="mr-2" />
          <Collapse
            className="d-sm-inline-flex flex-sm-row-reverse"
            isOpen={!collapsed}
            navbar
          >
            <ul className="navbar-nav flex-grow">
              <GetLogsLink />
              <GetAdministrationLink />
              <GetCompaniesLink />
              <GetProfileLink />
              <NavItem>
                <NavLink onClick={logout} className="c-pointer nav-menu-color">
                  Déconnexion
                </NavLink>
              </NavItem>
              <NavbarText><b>{currentUser.username}</b></NavbarText>
            </ul>
          </Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default observer(NavMenu);
